import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { education } from "../../data/constants";
import EducationCard from "../Cards/EducationCard";

const Education = () => {
  return (
    <Box id="education" sx={{ py: { xs: 8, md: 14 } }}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="flex-end" spacing={4} sx={{ mb: 10 }}>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif", fontWeight: 300,
            fontSize: { xs: "2.5rem", md: "4.5rem" }, color: "#e6e8ec",
            lineHeight: 1, letterSpacing: "-0.02em",
          }}>
            TRAINING
          </Typography>
          <Box sx={{ flex: 1, height: 1, bgcolor: "rgba(107, 117, 130, 0.3)", mb: 2 }} />
          <Typography sx={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: "0.85rem",
            color: "#6b7582", letterSpacing: "0.1em", mb: 2, display: { xs: "none", sm: "block" }
          }}>
            ACADEMIC FOUNDATIONS
          </Typography>
        </Stack>

        <Timeline sx={{
          [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 }
        }}>
          {education.map((item, idx) => (
            <TimelineItem key={item.id || idx}>
              <TimelineSeparator>
                <TimelineDot sx={{
                  bgcolor: "transparent", width: 10, height: 10,
                  border: "2px solid #00f0ff", borderRadius: 0, 
                  boxShadow: "0 0 10px rgba(0, 240, 255, 0.4)"
                }} />
                {idx !== education.length - 1 && (
                  <TimelineConnector sx={{ width: 1, bgcolor: "rgba(0, 240, 255, 0.15)" }} />
                )}
              </TimelineSeparator>
              <TimelineContent sx={{ py: 2, px: { xs: 2, md: 4 } }}>
                <EducationCard education={item} index={idx} />
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Container>
    </Box>
  );
};

export default Education;
